import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-143e9333"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-inline-block tw-ml-[15px] tw-text-[13px] tw-text-[#231F20] text-message tw-flex-1" }
const _hoisted_2 = { class: "tw-font-medium" }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "tw-inline-block" }
const _hoisted_6 = { class: "tw-text-[#878787] tw-text-[11px] text-time tw-flex" }

import { getTimeFromNow } from "@/utils/dateTimeUtils";
import { Ref, ref } from "vue";
import avatar from "../common/avatar.vue";
import ButtonShowMore from "@/components/common/setting/buttonShowMore.vue";
import CustomDropDownItem from "@/components/common/customDropDownItem.vue";
import UnReadIcon from "../svgs/unReadIcon.vue";
import { getComponentUiText } from "@/utils/utilities";
import { SYSTEM_ACTION_TYPE, INDEX_PRIMARY_PAGE } from "@/utils/constants";
import store from "@/store";

export default /*#__PURE__*/_defineComponent({
  __name: 'notificationItem',
  props: {
  notification: {
    type: Object,
    required: true,
  },
  index: {
    type: [Number, String],
    default: "",
    required: false,
  },
},
  setup(__props) {

const props = __props;



let hoverStatus: Ref = ref(false);
const getTimeAgo = (time: string) => {
  return getTimeFromNow(time);
};

const markAsRead = async () => {
  await store.dispatch("Notification/putMakeAsUnreadNotification", {
    actionId: props.notification.systemActionId,
  });
};

const deleteNotification = async () => {
  await store.dispatch("Notification/deleteNotification", {
    actionId: props.notification.systemActionId,
  });
};

const onHover = (value) => {
  hoverStatus.value = value;
};

const getNotificationData = (notification) => {
  switch (notification.typeId) {
    case SYSTEM_ACTION_TYPE.ORG_ACCESS_OFFER:
      return {
        title: getComponentUiText(
          "app-notification-item-title-offer-type-1",
          false,
          {
            orgName: notification.orgToOrgOfferOrg1Name,
          },
        ),
        link: "",
      };

    case SYSTEM_ACTION_TYPE.ORG_ACCESS_REQUEST:
      return {
        title: getComponentUiText(
          "app-notification-item-title-request-type-1",
          false,
          {
            orgName: notification.orgToOrgRequestOrg1Name,
            userOrgName: notification.user.companyName,
          },
        ),
        link: "",
      };

    case SYSTEM_ACTION_TYPE.CHECKLIST_REQUESTED_SUBMIT:
      return {
        title: getComponentUiText(
          "app-notification-item-title-request-submit-type-1",
        ),
        link: getComponentUiText(
          "app-notification-item-title-view-assessment-1",
        ),
        href: notification.checklistRequestedId
          ? `/assess/vendor/review/${notification.checklistRequestedId}`
          : `/assess/vendor/manage`,
        action: () => {
          store.dispatch(
            "Navigation/setPrimaryMenuIndex",
            INDEX_PRIMARY_PAGE.assessmentVendor,
          );
        },
      };

    case SYSTEM_ACTION_TYPE.ORG_ACCESS_REQUEST_PROCESSED:
      return {
        title: getComponentUiText(
          "app-notification-item-title-access-request-processed-type-1",
        ),
        link: getComponentUiText("app-notification-item-title-view-access-1"),
        href: `/settings/organisation/access`,
        action: () => {
          store.dispatch(
            "Navigation/setPrimaryMenuIndex",
            INDEX_PRIMARY_PAGE.setting,
          );
        },
      };

    case SYSTEM_ACTION_TYPE.ORG_ACCESS_OFFER_PROCESSED:
      return {
        title: getComponentUiText(
          "app-notification-item-title-access-offer-processed-type-1",
        ),
        link: getComponentUiText("app-notification-item-title-view-access-1"),
        href: `/settings/organisation/access`,
        action: () => {
          store.dispatch(
            "Navigation/setPrimaryMenuIndex",
            INDEX_PRIMARY_PAGE.setting,
          );
        },
      };

    default:
      return {
        title: getComponentUiText(
          "app-notification-item-title-not-exits-type-1",
          false,
          {
            type: notification?.type,
          },
        ),
      };
  }
};

const notificationData = ref(getNotificationData(props.notification));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`notification-more-button tw-items-center tw-flex tw-px-[25px] tw-py-[18px] tw-border border-box ${
      _unref(hoverStatus) ? 'item-selected' : ''
    }`)
  }, [
    _createVNode(avatar, {
      img: __props.notification.user.avatar,
      "alt-name": __props.notification.user.name
    }, null, 8, ["img", "alt-name"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _createTextVNode(_toDisplayString(notificationData.value.title), 1),
        (notificationData.value.link)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: notificationData.value.href,
              class: "tw-underline tw-ml-1",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (notificationData.value.action && notificationData.value.action(...args)))
            }, _toDisplayString(notificationData.value.link), 9, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _hoisted_4,
      _createElementVNode("span", _hoisted_5, _toDisplayString(__props.notification.systemActionNotes), 1),
      _createElementVNode("span", _hoisted_6, _toDisplayString(getTimeAgo(__props.notification.systemActionDateAdded)), 1)
    ]),
    (!__props.notification.systemActionIsRead)
      ? (_openBlock(), _createBlock(UnReadIcon, {
          key: 0,
          class: "tw-mr-[15px]"
        }))
      : _createCommentVNode("", true),
    _createVNode(ButtonShowMore, {
      "id-popover": 'popover-btn-show-more-notification-item-' + __props.index,
      "is-from-notification": true,
      onOnHover: onHover
    }, {
      default: _withCtx(() => [
        _createVNode(CustomDropDownItem, {
          style: 'normal',
          "id-text": 'app-notification-view-more-option-1'
        }),
        _createVNode(CustomDropDownItem, {
          style: 'normal',
          "id-text": `${
            __props.notification.systemActionIsRead
              ? 'app-notification-mark-as-unread-option-block-1'
              : 'app-notification-mark-as-read-option-block-1'
          }`,
          onClick: markAsRead
        }, null, 8, ["id-text"]),
        _createVNode(CustomDropDownItem, {
          style: 'danger',
          "id-text": 'app-notification-delete-notification-option-block-1',
          onClick: deleteNotification
        })
      ]),
      _: 1
    }, 8, ["id-popover"])
  ], 2))
}
}

})